import React, { useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import { useTrackVisibility } from 'react-intersection-observer-hook';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

export const AnimatedNumberCounter = ({
    toValue = 0,
    onEnd = () => {},
    decimalPlaces = null
}) => {
    const [ref, { isVisible }] = useTrackVisibility();
    const [hasStarted, setHasStarted] = useState(false);
    const [ended, setEnded] = useState(false);

    useEffect(() => {
        if (isVisible && !hasStarted) {
            setHasStarted(true);
        }
    }, [hasStarted, isVisible]);

    const numValue = Number(toValue);

    const { number } = useSpring({
        number: (hasStarted ? numValue : 0),
        from: { number: 0 },
        delay: 200,
        config: { mass: 1, tension: 30, friction: 10 },
        onRest: () => {
            setEnded(true);
            onEnd?.();
        }
    });

    if (isNaN(decimalPlaces) && toValue % 1 !== 0) {
        decimalPlaces = toValue.toString().split('.')[1].length;
    }

    const output = number.to(
        /** @param {number} val */
        (val) => val.toFixed(decimalPlaces)
    );

    return (
        <div className='w-min'>
            <animated.div ref={ref}>
                {ended && (
                    <span>
                        {decimalPlaces !== 0 && (
                            toValue.toFixed(decimalPlaces)
                        )}
                        {decimalPlaces === 0 && (
                            toValue
                        )}
                    </span>
                )}
                {!ended && (
                    <animated.span>
                        {output}
                    </animated.span>
                )}
            </animated.div>
        </div>
    );
};

export default AnimatedNumberCounter;
